import * as React from 'react';

import Styles from './Heromtavari.module.css';
import Hero from './Hero';









const Heromtavari = () => {
    return (

<div className={Styles.first_place}>
        <div className={Styles.main_page}>
            <div className={Styles.hh}>

                <h1 >FIND YOUR BEST CAR RENTAL WITH AVIS</h1>
            </div>

          
            <div>
                <Hero />

            </div>






        </div>
        <div className={Styles.canti}>
            
        </div>
        </div>
    );
}

export default Heromtavari;
